"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var regx_1 = __importDefault(require("regx"));
var cheerio_utils_1 = require("./cheerio-utils");
var walkBackwards_1 = __importDefault(require("./walkBackwards"));
// https://github.com/quentez/talonjs/blob/26de2941d9ea739e12853534717a820c72a6f8e9/src/Regexp.ts#L9:L9
var ON_REGEXP = regx_1.default('i')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t^s*(", ")\n  s\n"], ["\n\t^\\s*("
    // Beginning of the line.
    ,
    ")\n  \\s\n"])), 
// Beginning of the line.
[
    'On',
    'Le',
    'W dniu',
    'Op',
    'Am',
    'På',
    'Den',
    'Em',
    'El', // Spanish
].join('|'));
var WROTE_REGEXP = regx_1.default('i')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  s(", ")\n  s?:?s*$\n"], ["\n  \\s("
    // Ending of the line.
    ,
    ")\n  \\s?:?\\s*$\n"])), 
// Ending of the line.
[
    'wrote',
    'sent',
    'a écrit',
    'napisał',
    'schreef',
    'verzond',
    'geschreven',
    'schrieb',
    'skrev',
    'escreveu',
    'escribió', // Spanish
].join('|'));
function isQuoteHeaderStart(el) {
    return ON_REGEXP.test(el.data);
}
function isQuoteHeaderEnd(el) {
    return WROTE_REGEXP.test(el.data);
}
/**
 * Loop through doc DOM-element starting from the bottom and search for a string like:
 * "On Friday, 27 November 2015, Your Tempo <contact@yourtempo.co> wrote:"
 * These nodes are returned to be deleted.
 */
function findQuoteString($) {
    var e_1, _a;
    var nodesToRemove = [];
    // If we have seen a "... wrote:" yet
    var seenQuoteHeaderEnd = false;
    var top = cheerio_utils_1.getTopLevelElement($);
    try {
        // loop through childNodes backwards
        for (var _b = __values(walkBackwards_1.default(top)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var el = _c.value;
            if (cheerio_utils_1.isDocument(el)) {
                continue;
            }
            if (cheerio_utils_1.isText(el)) {
                if (cheerio_utils_1.isEmpty(el)) {
                    // Ignore empty texts
                    continue;
                }
                if (!seenQuoteHeaderEnd) {
                    if (isQuoteHeaderEnd(el)) {
                        seenQuoteHeaderEnd = true;
                        nodesToRemove.push(el);
                        // Check if On... + wrote... are in the same node...
                        if (isQuoteHeaderStart(el)) {
                            // We're done. Stop iterating
                            break;
                        }
                        else {
                            continue;
                        }
                    }
                    else {
                        // We have reached content. Stop iterating
                        break;
                    }
                }
                else {
                    // We are inside the quote header. So we remove everything
                    nodesToRemove.push(el);
                    // Until we reach the start of the header
                    if (isQuoteHeaderStart(el)) {
                        // This node is also the start of the header. We're done
                        break;
                    }
                    else {
                        continue;
                    }
                }
            }
            else {
                // It's not a text
                if (seenQuoteHeaderEnd) {
                    // It's inside the quote
                    nodesToRemove.push(el);
                }
                continue;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return nodesToRemove;
}
exports.default = findQuoteString;
var templateObject_1, templateObject_2;
